var file_upload_viewer_default = {
  "fontElementMap": "_0tUGV",
  "file_upload_container": "wm84H",
  "file_upload_link": "dMRIU",
  "file_upload_error_container": "Ux-IB",
  "file_upload_file_info": "Boxjt",
  "file_upload_type_icon": "dsInx",
  "file_upload_status_icon_container": "NnTPB",
  "file_upload_status_icon": "_2-Wxy",
  "file_upload_description": "OL3dK",
  "file_upload_name_container": "hQFTG",
  "file_upload_name": "pjU-0",
  "file_upload_extension": "GHgQg",
  "file_loader_icon": "Sf-El",
  "file_upload_icon_frame": "jcMTG",
  "file_upload_icon_background": "cyjlL"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
